'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function GoldSessionNodeSelectionTracker({goldSessionModel, mapModel, webSocketShim}) {
	const self = observable(this),
		isNodeSelectionChanged = item => item && item.action === 'nodeSelectionChanged';

	webSocketShim.addEventListener('message', (message)  => {
		if (!message) {
			return;
		}
		if (message.type === 'client:message') {
			const data = message.data;
			if (Array.isArray(data)) {
				const recentFirst = data.slice(0).reverse(),
					item = recentFirst.find(isNodeSelectionChanged);

				if (item) {
					const senderSession = goldSessionModel.getSession(message.sessionId),
						toDispatch = Object.assign({senderSession}, item);
					if (senderSession) {
						self.dispatchEvent(item.action, toDispatch);
					}
				}
			}
		}
	});
	mapModel.addEventListener('nodeSelectionChanged', async (nodeId, isSelected) => {
		if (isSelected && goldSessionModel.hasRemoteSessions()) {
			webSocketShim.send({action: 'nodeSelectionChanged', nodeId});
		}
	});
	goldSessionModel.addEventListener('sessionAdded', () => {
		webSocketShim.send({action: 'nodeSelectionChanged', nodeId: mapModel.getSelectedNodeId()});
	});
	mapModel.addEventListener('mapViewResetRequested', () => {
		webSocketShim.send({action: 'nodeSelectionChanged', nodeId: mapModel.getSelectedNodeId()});
	});
};
